import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-angular-grid-sample',
  templateUrl: './angular-grid-sample.component.html',
  styleUrls: ['./angular-grid-sample.component.css']
})
export class AngularGridSampleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
